import { withStyles } from 'tss-react/mui';
import { IBusinessCollectionProps } from '../../../../../Types/ObjektVy';
import FakturabilderQuery from './Queries/Fakturabilder/FakturabilderQuery';
import { Fakturabilder_node_TEDLRLeverantorfaktura } from './Queries/Fakturabilder/_QueryTypes/Fakturabilder';
import EDTypography from '../../../../../BaseComponents/Typography/EDTypography';
import Fakturabild from '../../../../../Components/Fakturabild/Fakturabild';
import classNames from 'classnames';
import { selectedId } from '../../../../../Components/MasterDetail/MasterDetailUtils';

interface IProps extends IBusinessCollectionProps {
  extraBottomPadding?: boolean;
  leverantorfaktura?: Fakturabilder_node_TEDLRLeverantorfaktura;
  leverantorfakturaLoading?: boolean;
  menuCaption?: string;
  noFullscreenToggle?: boolean;
  noPadding?: boolean;
  verifikationsNr?: string;
  useWheelToScroll: boolean;
  classes?: any;
  ignoreFloatingMenu?: boolean;
}

const styles = {
  mainContainer: {
    height: '100%',
  },
  mainContainerPadding: {
    height: 'calc(100% - 32px)',
    padding: 16,
  },
  container: {
    display: 'inherit',
    flexDirection: 'inherit',
  },
  emptyContainer: {
    flex: '0 1 100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
  },
};

const FakturaSidorComponent: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { noFullscreenToggle = true, extraBottomPadding = true } = props;
  return (
    <FakturabilderQuery
      id={selectedId(props.id)}
      leverantorfaktura={props.leverantorfaktura}
    >
      {fakturabilder => (
        <div
          className={classNames(props.classes.mainContainer, {
            [props.classes.mainContainerPadding]: !props.noPadding,
          })}
        >
          {fakturabilder.loading && (
            <EDTypography
              variant="body2"
              color="textSecondary"
              className={props.classes.emptyContainer}
            >
              Hämtar fakturabilder
            </EDTypography>
          )}
          {fakturabilder.bilder.length === 0 &&
            !props.leverantorfakturaLoading &&
            !fakturabilder.loading && (
              <EDTypography
                variant="body2"
                color="textSecondary"
                className={props.classes.emptyContainer}
              >
                Det finns inga fakturabilder att visa här
              </EDTypography>
            )}
          {fakturabilder.bilder.length > 0 && (
            <Fakturabild
              title=""
              fakturaBilder={fakturabilder.bilder}
              xmlFaktura={fakturabilder.xml}
              centeredImage
              noFullscreenToggle={noFullscreenToggle}
              extraBottomPadding={extraBottomPadding}
              skannadSvefaktura={fakturabilder.skannadSvefaktura}
              xmlFakturaFormat={fakturabilder.format}
              verifikationsNr={fakturabilder.defAnkVernr}
              bildUrls={fakturabilder.bildUrls}
              fakturaId={selectedId(props.id)}
              useWheelToScroll={props.useWheelToScroll}
              ignoreFloatingMenu={props.ignoreFloatingMenu}
            />
          )}
        </div>
      )}
    </FakturabilderQuery>
  );
};

export default withStyles(FakturaSidorComponent, styles);
